import React from 'react';
import classNames from 'classnames';
import jQuery from 'jquery';

export class Image extends React.Component {
	image = null;
	imageRef = null;
	zoomImageRef = null;

	constructor(props) {
		super(props);
		this.state = {
			backgroundImage: null,
			zoom: false,
			cursorX: 0,
			cursorY: 0
		};

	}

	render() {
		const style = {
			backgroundImage: this.state.backgroundImage ? `url(${this.state.backgroundImage})` : null,
			filter: this.state.filter || null,
		};
		if(this.props.hideIfInactive && !this.props.image.active) {
			style.display = 'none';
		}

		let attrs = {};
		if(this.props.zoom) {
			attrs = {
				onMouseEnter: () => {
					this.setState({zoom: true});
					setTimeout(() => jQuery(this.zoomImageRef).fadeIn(150), 50);
				},
				onMouseLeave: () => {
					setTimeout(() => jQuery(this.zoomImageRef).fadeOut(150), 200);
				},
				onMouseMove: e => {
					this.setState({cursorX: e.pageX, cursorY: e.pageY})
				}
			};
		}

		return (
			<div>
				<div
					ref={ref => this.imageRef = ref}
					className={classNames({'element--image-gallery--image': true, 'active': this.props.image.active})}
					style={style}
					title={this.props.image.alt}
					onClick={this.props.onClick}
					{...attrs}
				/>
				{this.state.zoom && <div className="element--image-gallery--zoom-image" ref={ref => this.zoomImageRef = ref} style={this.getZoomStyle()}><div style={this.innerZoomStyle()} /></div>}
			</div>
		)
	}

	componentDidMount() {
		this.phaseOne();
	}

	phaseOne() {
		this.image = document.createElement('img');
		this.image.onload = () => this.phaseTwo();
		this.image.src = this.props.image.lores;
		this.setState({backgroundImage: this.image.src, filter: 'blur(10px)'});
	}

	phaseTwo() {
		this.image = document.createElement('img');
		this.image.onload = () => this.setState({backgroundImage: this.image.src, filter: null});
		this.image.src = this.props.image.hires;
		if(this.image.complete) {
            this.setState({backgroundImage: this.image.src, filter: null});
        }
	}

	getZoomStyle() {
		const imageRef = jQuery(this.imageRef);
		return {
			position: 'absolute',
			backgroundColor: 'white',
			zIndex: 10000,
			overflow: 'hidden',
			left: imageRef.position().left + imageRef.width() + 10,
			top: imageRef.position().top,
			width: imageRef.width(),
			height: imageRef.outerHeight(),
		};
	}

	innerZoomStyle() {
		const imageRef = jQuery(this.imageRef);
		const cursor = {
			x: Math.floor((this.state.cursorX - imageRef.offset().left) / imageRef.width() * 100),
			y: Math.floor((this.state.cursorY - imageRef.offset().top) / imageRef.outerHeight() * 100),
		};
		return {
			position: 'absolute',
			backgroundImage: `url(${this.props.image.hires})`,
			backgroundSize: 'contain',
			backgroundRepeat: 'no-repeat',
			backgroundPosition: 'center center',
			zIndex: 10001,
			marginLeft: `${-cursor.x}%`,
			marginTop: `${-cursor.y}%`,
			top: 0,
			left: 0,
			width: imageRef.width() * 2,
			height: imageRef.outerHeight() * 2,
		};
	}
}
